// 🎧 ESCUCHA Y COMPRENDE — Parte II §0 y §2 del documento maestro.
//
// Mide comprensión auditiva general. La pregunta y las opciones solo aparecen
// después de que el audio termina (o tras 1 replay), tal como exige el
// documento: "Sin transcripción visible... fuerza oído real".
import { useState } from 'react';
import AudioPlayer from './AudioPlayer';

const LETTERS = ['a', 'b', 'c', 'd'];

export default function SlideEscuchaComprende({ slide, onAnswer, locked }) {
  const [audioDone, setAudioDone] = useState(false);
  const [picked, setPicked] = useState(null);

  const handlePick = (opt) => {
    if (picked || locked) return;
    setPicked(opt.id);
    onAnswer(opt.correct);
  };

  return (
    <>
      <AudioPlayer slide={slide} onFinished={() => setAudioDone(true)} />

      {audioDone && (
        <>
          <p className="ob-subhead">{slide.question}</p>
          <div className="ob-choice-grid">
            {slide.options.map((opt, i) => {
              const revealed = picked !== null;
              const cls = revealed ? (opt.correct ? ' ob-correct' : ' ob-dimmed') : '';
              return (
                <button
                  key={opt.id}
                  type="button"
                  className={`ob-choice${cls}`}
                  onClick={() => handlePick(opt)}
                  disabled={revealed || locked}
                >
                  <span className="ob-choice-letter">{LETTERS[i]}</span>
                  <span>{opt.text}</span>
                </button>
              );
            })}
          </div>
        </>
      )}
    </>
  );
}
